/* =====================================================================
   FLOW STORE — scripts do tema
   ===================================================================== */
(function () {
  'use strict';

  var T = window.FlowTheme || { routes: {}, strings: {} };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Dinheiro ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Bloquear rolagem ---------- */
  var lockCount = 0;
  function lock() { lockCount++; document.body.classList.add('is-locked'); }
  function unlock() { lockCount = Math.max(0, lockCount - 1); if (!lockCount) document.body.classList.remove('is-locked'); }

  /* ---------- Gavetas ---------- */
  function openDrawer(el) {
    if (!el || el.classList.contains('is-open')) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lock();
    var panel = $('.drawer__panel', el);
    if (panel) setTimeout(function () { panel.focus(); }, 50);
  }
  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    unlock();
  }

  /* Menu ☰ */
  var menuDrawer = $('[data-menu-drawer]');
  $$('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openDrawer(menuDrawer);
      $$('.header__menu-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      if (btn.hasAttribute('data-focus-search')) {
        var input = $('#MenuSearch');
        if (input) setTimeout(function () { input.focus(); }, 120);
      }
    });
  });
  $$('[data-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeDrawer(menuDrawer);
      $$('.header__menu-btn').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
  });

  /* ---------- Carrinho ---------- */
  var cartDrawer = $('[data-cart-drawer]');

  function getCart() {
    return fetch((T.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', !count);
    });
    $$('[data-cart-count-label]').forEach(function (el) { el.textContent = count ? '(' + count + ')' : ''; });
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!cartDrawer) return;
    var body = $('[data-cart-items]', cartDrawer);
    var foot = $('[data-cart-foot]', cartDrawer);
    if (!cart.item_count) {
      body.innerHTML = '<p class="drawer__empty">' + escapeHtml(T.strings.cartEmpty) + '</p>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item, i) {
      var img = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + (item.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">'
        : '';
      var variant = item.product_has_only_default_variant ? '' : '<p class="mini-line__variant">' + escapeHtml(item.variant_title) + '</p>';
      var discounts = (item.discounts || []).map(function (d) {
        return '<p class="mini-line__disc">' + escapeHtml(d.title) + ' (-' + formatMoney(d.amount) + ')</p>';
      }).join('');
      var was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
      return '<div class="mini-line">' +
        '<a class="mini-line__img" href="' + item.url + '">' + img + '</a>' +
        '<div>' +
          '<a class="mini-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
          variant + discounts +
          '<div class="cart-line__row">' +
            '<div class="qty qty--small">' +
              '<button type="button" data-drawer-qty="' + (i + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="-"><svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-drawer-qty="' + (i + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="+"><svg class="icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="mini-line__remove" data-drawer-qty="' + (i + 1) + '" data-to="0">' + escapeHtml(T.strings.remove) + '</button>' +
        '</div>' +
        '<div class="mini-line__price">' + was + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    }).join('');
    var disc = $('[data-cart-discounts]', cartDrawer);
    if (disc) {
      disc.innerHTML = (cart.cart_level_discount_applications || []).map(function (d) {
        return '<div class="summary-row"><span>' + escapeHtml(d.title) + '</span><span>-' + formatMoney(d.total_allocated_amount) + '</span></div>';
      }).join('');
    }
    $('[data-cart-total]', cartDrawer).textContent = formatMoney(cart.total_price);
    foot.hidden = false;
  }

  function changeLine(line, quantity) {
    return fetch((T.routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    }).then(function (r) { return r.json(); });
  }

  function openCart() {
    getCart().then(function (cart) { renderCart(cart); openDrawer(cartDrawer); });
  }

  if (cartDrawer) {
    $$('[data-drawer-close]', cartDrawer).forEach(function (b) { b.addEventListener('click', function () { closeDrawer(cartDrawer); }); });
    cartDrawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-drawer-qty]');
      if (!btn) return;
      btn.disabled = true;
      changeLine(parseInt(btn.getAttribute('data-drawer-qty'), 10), parseInt(btn.getAttribute('data-to'), 10)).then(renderCart);
    });
  }

  if (T.cartType === 'drawer' && !document.querySelector('[data-cart-page]')) {
    $$('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDrawer(cartDrawer);
    closeDrawer(menuDrawer);
    closeGift();
  });

  /* Adicionar ao carrinho (todos os formulários de produto) */
  function addToCart(form, buyNow) {
    var button = $('[data-add-button]', form);
    var label = button ? (button.querySelector('[data-add-label]') || button) : null;
    var original = label ? label.innerHTML : '';
    if (button) { button.disabled = true; }
    if (label && !buyNow) label.textContent = T.strings.adding;
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || 'Error');
        if (buyNow) { window.location.href = '/checkout'; return; }
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); return; }
        if (T.cartType === 'drawer') { openCart(); } else { window.location.href = T.routes.cart || '/cart'; }
      })
      .catch(function (err) { alert(err.message); })
      .then(function () {
        if (button) button.disabled = false;
        if (label && !buyNow) label.innerHTML = original;
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, false);
  });

  /* ---------- Página do carrinho ---------- */
  var cartPage = $('[data-cart-page]');
  if (cartPage) {
    cartPage.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line-change]');
      if (!btn) return;
      btn.disabled = true;
      changeLine(parseInt(btn.getAttribute('data-line-change'), 10), parseInt(btn.getAttribute('data-qty-to'), 10))
        .then(function () { window.location.reload(); });
    });
    var promo = $('[data-promo-form]', cartPage);
    if (promo) {
      promo.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = (promo.code.value || '').trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(T.routes.cart || '/cart');
      });
    }
  }

  /* Ordenar coleção */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Página de produto ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = $('[data-product-form]', section);
    var idInput = $('[data-variant-id]', section);
    var qtyInput = $('[data-quantity]', section);
    var addBtn = $('[data-add-button]', section);
    var addLabel = $('[data-add-label]', section);
    var buyNowBtn = $('[data-buy-now]', section);
    var bundles = $('[data-bundles]', section);
    var current = product.variants.filter(function (v) { return String(v.id) === (idInput ? idInput.value : ''); })[0] || product.variants[0];

    /* Galeria */
    var viewport = $('[data-gallery-viewport]', section);
    var slides = viewport ? $$('.gallery__slide', viewport) : [];
    var dots = $$('.gallery__dot', section);
    var thumbs = $$('[data-thumb]', section);
    function goTo(index) {
      if (!viewport || !slides[index]) return;
      viewport.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function activeIndex() {
      if (!viewport) return 0;
      return Math.round(viewport.scrollLeft / Math.max(1, viewport.clientWidth));
    }
    if (viewport) {
      viewport.addEventListener('scroll', function () {
        var i = activeIndex();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      }, { passive: true });
      var prev = $('[data-gallery-prev]', section);
      var next = $('[data-gallery-next]', section);
      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, activeIndex() - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, activeIndex() + 1)); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    }
    function showMedia(mediaId) {
      if (!mediaId) return;
      var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goTo(idx);
    }

    /* Preços */
    function setPrices(variant) {
      $$('[data-price]', section).forEach(function (box) {
        var cur = $('[data-price-current]', box);
        var cmp = $('[data-price-compare]', box);
        var badge = $('[data-price-badge]', box);
        if (cur) cur.textContent = formatMoney(variant.price);
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        box.classList.toggle('price--sale', !!sale);
        if (cmp) { cmp.hidden = !sale; cmp.textContent = sale ? formatMoney(variant.compare_at_price) : ''; }
        if (badge) {
          badge.hidden = !sale;
          if (sale) {
            var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
            badge.textContent = (badge.getAttribute('data-label') || 'Save') + ' ' + pct + '%';
          }
        }
      });
      if (bundles) {
        var compare = Math.max(variant.compare_at_price || 0, variant.price);
        $$('[data-bundle]', bundles).forEach(function (card) {
          var q = parseInt(card.getAttribute('data-bundle'), 10);
          var off = parseInt(card.getAttribute('data-off'), 10) || 0;
          var total = Math.round(variant.price * q * (100 - off) / 100);
          var was = compare * q;
          $('[data-bundle-total]', card).textContent = formatMoney(total);
          var w = $('[data-bundle-was]', card);
          w.hidden = was <= total;
          w.textContent = formatMoney(was);
          var each = $('[data-bundle-each]', card);
          each.textContent = each.textContent.replace(/^[^/]+/, formatMoney(Math.round(total / q)) + ' ');
        });
      }
      updateSticky(variant);
    }

    /* Barra fixa: mostra o total do kit escolhido (ou preço × quantidade) */
    function updateSticky(variant) {
      var sp = $('[data-sticky-price]', section);
      if (!sp) return;
      var checked = bundles ? $('input:checked', bundles) : null;
      if (checked) {
        sp.textContent = $('[data-bundle-total]', checked.closest('[data-bundle]')).textContent;
      } else {
        sp.textContent = formatMoney((variant || current).price * (qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1));
      }
    }

    function setAvailability(variant) {
      var ok = variant && variant.available;
      if (addBtn) addBtn.disabled = !ok;
      if (buyNowBtn) buyNowBtn.disabled = !ok;
      var stickyBtn = $('[data-sticky-add]', section);
      if (stickyBtn) stickyBtn.disabled = !ok;
      if (addLabel) addLabel.textContent = ok ? (addLabel.getAttribute('data-label') || T.strings.addToCart) : (variant ? T.strings.soldOut : T.strings.unavailable);
    }

    /* Variantes */
    var picker = $('[data-variant-picker]', section);
    if (picker) {
      picker.addEventListener('change', function () {
        var selected = [];
        $$('fieldset', picker).forEach(function (fs, i) {
          var checked = $('input:checked', fs);
          selected[i] = checked ? checked.value : null;
          var label = $('[data-option-value="' + i + '"]', picker);
          if (label && checked) label.textContent = checked.value;
        });
        var variant = product.variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        })[0];
        setAvailability(variant);
        if (!variant) return;
        current = variant;
        if (idInput) idInput.value = variant.id;
        setPrices(variant);
        if (variant.featured_media) showMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    /* Kits Single/Duo/Trio */
    function syncBundle() {
      if (!bundles || !qtyInput) return;
      var checked = $('input:checked', bundles);
      qtyInput.value = checked ? checked.value : 1;
      updateSticky();
    }
    if (bundles) { bundles.addEventListener('change', syncBundle); syncBundle(); }

    /* Seletor de quantidade simples */
    var qtyBox = $('[data-qty]', section);
    if (qtyBox && qtyInput) {
      var visible = $('[data-qty-input]', qtyBox);
      var set = function (n) { n = Math.max(1, n || 1); visible.value = n; qtyInput.value = n; updateSticky(); };
      $('[data-qty-minus]', qtyBox).addEventListener('click', function () { set(parseInt(visible.value, 10) - 1); });
      $('[data-qty-plus]', qtyBox).addEventListener('click', function () { set(parseInt(visible.value, 10) + 1); });
      visible.addEventListener('change', function () { set(parseInt(visible.value, 10)); });
    }

    /* Buy Now: adiciona e vai direto ao checkout */
    if (buyNowBtn && form) buyNowBtn.addEventListener('click', function () { addToCart(form, true); });

    /* Barra fixa de compra */
    var sticky = $('[data-sticky-buy]', section);
    var buyBox = $('[data-buy]', section);
    if (sticky && buyBox && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      var footer = document.querySelector('.footer');
      var buyVisible = true, footerVisible = false;
      var update = function () {
        var show = !buyVisible && !footerVisible && buyBox.getBoundingClientRect().top < 0;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-buy', show);
      };
      new IntersectionObserver(function (entries) { buyVisible = entries[0].isIntersecting; update(); }).observe(buyBox);
      if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
      $('[data-sticky-add]', sticky).addEventListener('click', function () {
        if (form && current && current.available) addToCart(form, false);
      });
    }

    setPrices(current);
  });

  /* "Like it? Buy Now": sobe até a área de compra */
  $$('[data-scroll-buy]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector('[id^="ProductBuy-"]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------- Avaliações ---------- */
  $$('[data-review-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById(btn.getAttribute('aria-controls'));
      if (!form) return;
      form.hidden = !form.hidden;
      btn.setAttribute('aria-expanded', String(!form.hidden));
      if (!form.hidden) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
  $$('[data-reviews-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var list = btn.closest('section').querySelector('[data-reviews-list]');
      var per = parseInt(list.getAttribute('data-per-page'), 10) || 6;
      var hidden = $$('[data-review-more][hidden]', list);
      hidden.slice(0, per).forEach(function (el) { el.hidden = false; });
      if (hidden.length <= per) btn.parentNode.hidden = true;
    });
  });

  /* ---------- Cupom de presente ---------- */
  var gift = $('[data-gift]');
  var giftModal = gift ? $('[data-gift-modal]', gift) : null;
  var giftBubble = gift ? $('[data-gift-bubble]', gift) : null;
  var KEY = 'flowGiftSeen';

  function seen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function markSeen() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function openGift() {
    if (!giftModal) return;
    giftModal.hidden = false;
    if (giftBubble) giftBubble.hidden = true;
    lock();
  }
  function closeGift() {
    if (!giftModal || giftModal.hidden) return;
    giftModal.hidden = true;
    unlock();
  }

  if (gift && !seen() && gift.getAttribute('data-auto') !== 'false' && !document.querySelector('[data-cart-page]')) {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var useBubble = isMobile && gift.getAttribute('data-mobile-bubble') === 'true';
    var threshold = parseInt(gift.getAttribute('data-scroll'), 10) || 0;
    var trigger = function () {
      if (window.scrollY < threshold) return;
      window.removeEventListener('scroll', trigger);
      markSeen();
      if (useBubble) { giftBubble.hidden = false; } else { openGift(); }
    };
    window.addEventListener('scroll', trigger, { passive: true });
    trigger();
  }
  if (gift) {
    if (giftBubble) giftBubble.addEventListener('click', openGift);
    $$('[data-gift-close]', gift).forEach(function (b) { b.addEventListener('click', closeGift); });
    var copyBtn = $('[data-gift-copy]', gift);
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = gift.getAttribute('data-code');
        var done = function () {
          var l = $('[data-gift-copy-label]', copyBtn);
          if (l) l.textContent = T.strings.copied;
        };
        if (navigator.clipboard) { navigator.clipboard.writeText(code).then(done, done); } else { done(); }
      });
    }
  }

  /* ---------- Animações ao rolar ---------- */
  var motion = document.documentElement.classList.contains('motion');
  var replay = document.body.getAttribute('data-replay') === 'true';

  /* Letras do banner entram uma a uma */
  $$('[data-split]').forEach(function (el) {
    if (!motion || el.getAttribute('data-split-done')) return;
    var text = el.textContent;
    el.textContent = '';
    Array.prototype.forEach.call(text, function (ch, i) {
      var span = document.createElement('span');
      span.className = 'ch';
      span.setAttribute('aria-hidden', 'true');
      span.style.setProperty('--i', i);
      span.textContent = ch === ' ' ? ' ' : ch;
      el.appendChild(span);
    });
    el.setAttribute('data-split-done', '1');
  });

  /* Título gigante do banner nunca passa da largura da tela */
  function fitTitles() {
    $$('.hx__title').forEach(function (el) {
      el.style.fontSize = '';
      var box = el.parentNode.clientWidth - 8;
      var size = parseFloat(getComputedStyle(el).fontSize);
      var guard = 0;
      while (el.scrollWidth > box && size > 28 && guard < 60) {
        size -= 4;
        el.style.fontSize = size + 'px';
        guard++;
      }
    });
  }
  fitTitles();
  window.addEventListener('resize', fitTitles);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);

  /* O que aparece ao rolar: [seletor, tipo, atraso em sequência entre irmãos] */
  var REVEAL = [
    ['.section-head', '', false],
    ['.grid > *', '', true],
    ['.story__media', '', false],
    ['.story__copy', '', false],
    ['.spotlight__copy > *', '', true],
    ['.spotlight__media', '', false],
    ['.about-video__copy > *', '', true],
    ['.about-video__media', 'fade', false],
    ['.trust__item', '', true],
    ['.highlights__grid > *', '', true],
    ['.acc-list > *', '', true],
    ['.reviews__summary', 'scale', false],
    ['.reviews__list > *', '', true],
    ['.faq__box', '', false],
    ['.contact-strip__content > *', '', true],
    ['.panels__row > .panel', '', true],
    ['.editorial__copy > *', '', true],
    ['.editorial__img', '', true],
    ['.footer__col', '', true],
    ['.footer__brand', 'scale', false],
    ['.hx__content > *:not(.hx__title)', '', true],
    ['.hx__card', 'fade', false],
    ['.product .trust__item', '', true],
    ['.cart-trending .grid > *', '', true]
  ];

  if (motion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          if (!replay) io.unobserve(entry.target);
        } else if (replay && entry.boundingClientRect.top > 0) {
          entry.target.classList.remove('is-in');
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    REVEAL.forEach(function (rule) {
      $$(rule[0]).forEach(function (el) {
        if (el.classList.contains('reveal') || el.closest('.drawer, .gift, .product__info')) return;
        el.classList.add('reveal');
        if (rule[1]) el.classList.add('reveal--' + rule[1]);
        if (rule[2]) {
          var idx = Array.prototype.indexOf.call(el.parentNode.children, el);
          el.style.setProperty('--reveal-delay', Math.min(idx, 8) * 0.09 + 's');
        }
        io.observe(el);
      });
    });

    /* Segurança: nada fica escondido. O que já está na tela (ou acima dela)
       aparece mesmo se o observador falhar. */
    var sweep = function () {
      var vh = window.innerHeight;
      $$('.reveal:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < vh) el.classList.add('is-in');
      });
    };
    var sweepTimer;
    window.addEventListener('scroll', function () {
      clearTimeout(sweepTimer);
      sweepTimer = setTimeout(sweep, 400);
    }, { passive: true });
    setTimeout(sweep, 1800);
  }

  /* Parallax suave */
  var parallaxOn = motion && document.body.getAttribute('data-parallax-enabled') === 'true';
  var pEls = parallaxOn ? $$('[data-parallax]') : [];
  if (pEls.length) {
    var ticking = false;
    var runParallax = function () {
      var vh = window.innerHeight;
      pEls.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0;
        var offset = (r.top + r.height / 2 - vh / 2) * speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      });
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(runParallax); }
    }, { passive: true });
    runParallax();
  }

  /* Banner: fotos trocam sozinhas */
  $$('[data-hx]').forEach(function (hx) {
    var slides = $$('.hx__slide', hx);
    var dots = $$('.hx__dot', hx);
    if (slides.length < 2) return;
    var i = 0;
    var ms = (parseInt(hx.getAttribute('data-interval'), 10) || 5) * 1000;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }, ms);
  });

  /* ---------- Abertura em sequência (fotos que avançam com a rolagem) ---------- */
  $$('[data-seq]').forEach(function (seq) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var urls;
    try { urls = JSON.parse(seq.getAttribute('data-frames') || '[]'); } catch (e) { urls = []; }
    if (urls.length < 2) return;

    var canvas = $('.seq__canvas', seq);
    var ctx = canvas.getContext('2d');
    var chapters = $$('[data-ch]', seq);
    var bar = $('.seq__progress', seq);
    var frames = new Array(urls.length);
    var loaded = 0;
    var progress = 0;
    var ticking = false;

    seq.classList.add('is-live');

    /* Carrega a primeira foto logo e o resto em seguida */
    urls.forEach(function (u, i) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () {
        frames[i] = img;
        loaded++;
        if (i === 0) { seq.classList.add('is-ready'); draw(); }
        else if (Math.abs(i - frameAt(progress)) < 2) draw();
      };
      img.src = u;
    });

    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, 1.75);
      var w = canvas.clientWidth, h = canvas.clientHeight;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      draw();
    }

    function nearest(i) {
      if (frames[i]) return frames[i];
      for (var d = 1; d < urls.length; d++) {
        if (frames[i - d]) return frames[i - d];
        if (frames[i + d]) return frames[i + d];
      }
      return null;
    }

    function cover(img, alpha, zoom) {
      if (!img) return;
      var cw = canvas.width, ch = canvas.height;
      var s = Math.max(cw / img.naturalWidth, ch / img.naturalHeight) * zoom;
      var w = img.naturalWidth * s, h = img.naturalHeight * s;
      ctx.globalAlpha = alpha;
      ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
    }

    /* Foto de cada parada: 1ª = janela, 2ª = fora da janela (foto 9), 3ª = última */
    var KEY = [0, Math.min(8, urls.length - 1), urls.length - 1];
    function frameAt(p) {
      if (p <= 0.5) return KEY[0] + (p / 0.5) * (KEY[1] - KEY[0]);
      return KEY[1] + ((p - 0.5) / 0.5) * (KEY[2] - KEY[1]);
    }

    function draw() {
      if (!canvas.width) return;
      var pos = frameAt(progress);
      var a = Math.floor(pos), b = Math.min(a + 1, urls.length - 1), t = pos - a;
      var zoom = 1 + progress * 0.05;
      cover(nearest(a), 1, zoom);
      if (t > 0.01 && b !== a) cover(nearest(b), t, zoom);
      ctx.globalAlpha = 1;
    }

    /* Capítulos: [início, fim] da rolagem (0 a 1) */
    var RANGES = [[0, 0.24], [0.3, 0.7], [0.78, 1.01]];
    function chapterState(p, r, i) {
      var fade = 0.07;
      var o;
      if (i === 0 && p <= r[1] - fade) o = 1;
      else if (p < r[0] || p > r[1]) o = 0;
      else if (p < r[0] + fade) o = (p - r[0]) / fade;
      else if (p > r[1] - fade && i < RANGES.length - 1) o = (r[1] - p) / fade;
      else o = 1;
      var mid = i === 0 ? 0 : (r[0] + r[1]) / 2;
      var y = (mid - p) * 140;
      return { o: Math.max(0, Math.min(1, o)), y: i === RANGES.length - 1 ? Math.max(0, y) : y };
    }

    function update() {
      ticking = false;
      var rect = seq.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      progress = total > 0 ? Math.max(0, Math.min(1, -rect.top / total)) : 0;
      draw();
      chapters.forEach(function (el, i) {
        var st = chapterState(progress, RANGES[i] || [0, 1], i);
        el.style.setProperty('--o', st.o.toFixed(3));
        el.style.setProperty('--y', st.y.toFixed(1) + 'px');
        if (i === RANGES.length - 1) el.style.setProperty('--s', (0.94 + st.o * 0.06).toFixed(3));
        el.classList.toggle('is-active', st.o > 0.5);
      });
      seq.style.setProperty('--hint', progress > 0.03 ? 0 : 1);
      if (bar) bar.style.setProperty('--p', progress.toFixed(4));
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', function () { size(); update(); fitTitles(); });

    /* Modo "passos": cada rolada leva direto para a próxima cena
       (janela → frase → FLOW STORE → resto da página), com transição rápida. */
    if (seq.getAttribute('data-mode') === 'steps') {
      var STOPS = [0, 0.5, 1];
      var speed = parseInt(seq.getAttribute('data-speed'), 10) || 850;
      var busy = false;
      var lockUntil = 0;

      var bounds = function () {
        var top = seq.getBoundingClientRect().top + window.scrollY;
        return { top: top, total: seq.offsetHeight - window.innerHeight };
      };
      var ease = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };

      var animateTo = function (y) {
        busy = true;
        var from = window.scrollY, dist = y - from, start = null;
        var step = function (ts) {
          if (start === null) start = ts;
          var t = Math.min(1, (ts - start) / speed);
          window.scrollTo({ top: from + dist * ease(t), behavior: 'instant' });
          if (t < 1) { requestAnimationFrame(step); }
          else { busy = false; lockUntil = Date.now() + 450; }
        };
        requestAnimationFrame(step);
      };

      /* Decide se a rolada é da abertura; devolve true se tratou */
      var go = function (dir) {
        var b = bounds();
        var y = window.scrollY;
        var inZone = y >= b.top - window.innerHeight * 0.5 && y <= b.top + b.total + 2;
        if (!inZone) return false;
        var p = Math.max(0, Math.min(1, (y - b.top) / b.total));
        var pos = p * (STOPS.length - 1);
        var idx = dir > 0 ? Math.floor(pos + 0.02) + 1 : Math.ceil(pos - 0.02) - 1;
        if (dir > 0 && y >= b.top + b.total - 2) return false;      /* fim: segue a página */
        if (dir < 0 && y <= b.top + 2) return false;                /* topo: segue normal */
        if (busy || Date.now() < lockUntil) return true;
        idx = Math.max(0, Math.min(STOPS.length - 1, idx));
        animateTo(b.top + STOPS[idx] * b.total);
        return true;
      };

      window.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) < 2 || e.ctrlKey) return;
        if (go(e.deltaY > 0 ? 1 : -1)) e.preventDefault();
      }, { passive: false });

      var touchY = null, touchUsed = false;
      window.addEventListener('touchstart', function (e) { touchY = e.touches[0].clientY; touchUsed = false; }, { passive: true });
      window.addEventListener('touchmove', function (e) {
        if (touchY === null) return;
        var dy = touchY - e.touches[0].clientY;
        if (touchUsed) { e.preventDefault(); return; }
        if (Math.abs(dy) < 12) return;
        if (go(dy > 0 ? 1 : -1)) { touchUsed = true; e.preventDefault(); }
      }, { passive: false });
      window.addEventListener('touchend', function () { touchY = null; }, { passive: true });

      document.addEventListener('keydown', function (e) {
        var tag = (e.target.tagName || '').toLowerCase();
        if (tag === 'input' || tag === 'textarea' || tag === 'select') return;
        var dir = { ArrowDown: 1, PageDown: 1, ' ': 1, ArrowUp: -1, PageUp: -1 }[e.key];
        if (dir && go(dir)) e.preventDefault();
      });
    }
    size();
    update();
    fitTitles();
  });

  /* Recuperar senha (página de login) */
  $$('[data-recover-toggle]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var box = document.getElementById('recover');
      if (box) box.scrollIntoView({ behavior: 'smooth' });
    });
  });
})();
